// Module
var code = "<md-nav-bar md-selected-nav-item=\"$ctrl.currentState\" md-no-ink-bar=\"true\"> <md-nav-item md-nav-sref=\"{{item.state}}\" name=\"{{item.state}}\" ng-repeat=\"item in $ctrl.items track by item.state\" ui-sref-active=\"active\" tmr-if-access=\"item.state\"> {{item.title | translate:item.titleVariables}} </md-nav-item> </md-nav-bar> ";
// Exports
var _module_exports =code;;
var path = 'components/navBar/navBar.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;